import axios from '@/libs/api.request';

export const getSerialList = data => {
    return axios.request({
        url: 'api/productManagement/serial/getSerialList',
        data: data,
        method: 'post'
    });
};

export const saveSerial = data => {
    return axios.request({
        url: 'api/productManagement/serial/saveSerial',
        data: data,
        method: 'post'
    });
};

export const deleteSerialByUuid = data => {
    return axios.request({
        url: 'api/productManagement/serial/deleteSerialByUuid',
        data: data,
        method: 'post'
    });
};
